<script setup lang="ts">
import { useUIStore } from "@/stores";
import { storeToRefs } from "pinia";
const { loading } = storeToRefs(useUIStore());
</script>

<template>
  <v-dialog v-model="loading">
    <v-container
      fill-height
      class="d-flex align-center justify-center bg-surface"
    >
      <v-progress-circular indeterminate color="primary"> </v-progress-circular>
      <p class="ml-3">CARREGANDO</p>
    </v-container>
  </v-dialog>
</template>
